var map = {
	"./addtoprofilebutton_de.png": 96,
	"./addtoprofilebutton_en.png": 97,
	"./addtoprofilebutton_fr.png": 98,
	"./award_land_der_ideen.jpg": 99,
	"./cc.png": 100,
	"./certificate_sample.jpg": 101,
	"./clear.png": 102,
	"./companies.jpg": 103,
	"./course-cover-default.jpg": 104,
	"./course-page-card_big.png": 105,
	"./course-page-card_image.png": 106,
	"./course-page-card_image_inline.png": 107,
	"./course-page-card_inline.png": 108,
	"./course-page-card_small.png": 109,
	"./course-placeholder.jpg": 110,
	"./course_default.png": 111,
	"./download-easy-guide.jpg": 112,
	"./drag_dark.png": 113,
	"./drag_light.png": 114,
	"./draggable.png": 115,
	"./example_voucher_card_de.jpg": 116,
	"./example_voucher_card_en.jpg": 117,
	"./example_voucher_card_fr.jpg": 118,
	"./fabian.jpg": 119,
	"./female_speaker_bg.jpg": 120,
	"./h5p_docu_1.png": 121,
	"./h5p_docu_2.png": 122,
	"./logo-iversity-without-padding.png": 123,
	"./logo-iversity.png": 124,
	"./logo_highres.png": 125,
	"./logo_iversity_springer.svg": 126,
	"./organisation_purchase.jpg": 127,
	"./petal_cutted.png": 128,
	"./posters_points.png": 129,
	"./professor_bg.jpg": 130,
	"./purchase_voucher_header.jpg": 131,
	"./referrals.jpg": 132,
	"./speech-bubble.svg": 133,
	"./voucher_card.png": 134,
	"./work_with_us.png": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;